module.exports = __webpack_public_path__ + "static/media/cancelMob.d1c48c6a.svg";